export const DEFAULT_COLOR = '#425b76';